/* Site-Specific JavaScript */

let last_footnote = '';

// Megamenu dropdown functionality
document.addEventListener('DOMContentLoaded', function() {
    
    // Support both legacy .nav-button and new .nav-link-parent
    const navLinks = document.querySelectorAll('.nav-link-parent[data-has-dropdown], .nav-button[data-has-dropdown]');
    const megamenuItems = document.querySelectorAll('.has-megamenu');
    const isMobile = () => window.innerWidth < 992; // Bootstrap lg breakpoint
    
    // Get megamenu element from parent li's data-submenu-id
    function getMegamenu(link) {
        const parentLi = link.closest('[data-submenu-id]');
        if (parentLi) {
            return document.getElementById(parentLi.getAttribute('data-submenu-id'));
        }
        return null;
    }
    
    // Function to close all megamenus
    function closeAllMegamenus() {
        document.querySelectorAll('.megamenu.show').forEach(menu => {
            menu.classList.remove('show');
        });
    }
    
    // Function to open a megamenu
    function openMegamenu(link) {
        const megamenu = getMegamenu(link);
        if (megamenu) {
            megamenu.classList.add('show');
        }
    }
    
    // Function to close a megamenu
    function closeMegamenu(link) {
        const megamenu = getMegamenu(link);
        if (megamenu) {
            megamenu.classList.remove('show');
        }
    }
    
    navLinks.forEach(link => {
        const parentLi = link.closest('.has-megamenu');
        const megamenu = getMegamenu(link);
        
        // Click behavior - on mobile toggle menu, on desktop navigate to first child
        link.addEventListener('click', function(e) {
            if (isMobile()) {
                // Mobile: toggle the megamenu
                e.preventDefault();
                e.stopPropagation();
                
                const isOpen = megamenu && megamenu.classList.contains('show');
                
                // Close all other megamenus first
                closeAllMegamenus();
                
                // Toggle current megamenu
                if (!isOpen) {
                    openMegamenu(link);
                }
            }
            // Desktop: allow default link behavior (navigate to first child)
        });
        
        // Hover behavior for desktop only
        if (parentLi) {
            let hoverTimeout;
            
            parentLi.addEventListener('mouseenter', function() {
                if (!isMobile()) {
                    clearTimeout(hoverTimeout);
                    // Close other megamenus
                    closeAllMegamenus();
                    openMegamenu(link);
                    // Update borders after menu opens
                    setTimeout(updateMegamenuBorders, 50);
                }
            });
            
            parentLi.addEventListener('mouseleave', function() {
                if (!isMobile()) {
                    // Small delay before closing to allow moving to megamenu
                    hoverTimeout = setTimeout(() => {
                        closeMegamenu(link);
                    }, 100);
                }
            });
            
            // Keep megamenu open when hovering over it
            if (megamenu) {
                megamenu.addEventListener('mouseenter', function() {
                    if (!isMobile()) {
                        clearTimeout(hoverTimeout);
                    }
                });
                
                megamenu.addEventListener('mouseleave', function() {
                    if (!isMobile()) {
                        hoverTimeout = setTimeout(() => {
                            closeMegamenu(link);
                        }, 100);
                    }
                });
            }
        }
    });
    
    // Close megamenus when pressing Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            closeAllMegamenus();
        }
    });
    
    // Close megamenus when tabbing out of the navigation area
    document.addEventListener('focusin', function(e) {
        // Check if focus is moving outside the main navigation
        const mainMenu = document.querySelector('.main-menu');
        if (mainMenu && !mainMenu.contains(e.target)) {
            // Delay to ensure focus has fully moved
            setTimeout(() => {
                closeAllMegamenus();
            }, 10);
        }
    });
    
    // Open megamenu on focus for keyboard navigation (desktop)
    navLinks.forEach(link => {
        link.addEventListener('focus', function() {
            if (!isMobile()) {
                // Close other megamenus
                closeAllMegamenus();
                openMegamenu(link);
                setTimeout(updateMegamenuBorders, 50);
            }
        });
    });
    
    // Function to update megamenu column borders based on row position
    function updateMegamenuBorders() {
        document.querySelectorAll('.megamenu-content').forEach(container => {
            const columns = Array.from(container.querySelectorAll('.megamenu-column'));
            
            // Reset all columns
            columns.forEach(col => col.classList.remove('last-in-row'));
            
            // Group columns by their top position (same row)
            const rows = {};
            columns.forEach(col => {
                const rect = col.getBoundingClientRect();
                const top = Math.round(rect.top); // Round to handle small pixel differences
                if (!rows[top]) rows[top] = [];
                rows[top].push(col);
            });
            
            // Mark the last column in each row
            Object.values(rows).forEach(row => {
                if (row.length > 0) {
                    row[row.length - 1].classList.add('last-in-row');
                }
            });
        });
    }
    
    // Run border update on page load
    updateMegamenuBorders();
    
    // Run border update when window is resized
    window.addEventListener('resize', updateMegamenuBorders);
    
    // Stats Rolling Animation
    function animateStats() {
        const statNumbers = document.querySelectorAll('.stat-number, .module-accordion .stat-value');
        
        const observerOptions = {
            threshold: 0.5,
            rootMargin: '0px 0px -50px 0px'
        };
        
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !entry.target.classList.contains('animated')) {
                    entry.target.classList.add('animated');
                    animateNumber(entry.target);
                }
            });
        }, observerOptions);
        
        statNumbers.forEach(stat => {
            observer.observe(stat);
        });
    }
    
    function animateNumber(element) {
        const target = element.getAttribute('data-target');
        const duration = 1000; // 2 seconds
        let current = 0;
        
        // Extract prefix, number and suffix (like CA$, %, +, k, M, etc.)
        const match = target.match(/^(.*?)([\d.]+)(.*)$/);
        if (!match) {
            // If we can't parse it, just show the original value
            element.textContent = target;
            return;
        }
        
        let prefix = match[1] || '';
        const targetNumber = parseFloat(match[2]);
        let suffix = match[3] || '';
        
        // Check if + is in prefix or suffix (we want to show it only after animation)
        const hasPlusPrefix = prefix.includes('+');
        const hasPlusSuffix = suffix.includes('+');
        
        // Remove + from prefix/suffix - we'll add it back at the end
        if (hasPlusPrefix) {
            prefix = prefix.replace('+', '');
        }
        if (hasPlusSuffix) {
            suffix = suffix.replace('+', '');
        }
        
        // Check if original number has decimal places
        const originalHasDecimal = match[2].includes('.');
        
        // Calculate increment based on actual target number, not the formatted string
        const increment = targetNumber / (duration / 16); // 60fps
        
        const timer = setInterval(() => {
            current += increment;
            
            let isComplete = false;
            if (current >= targetNumber) {
                current = targetNumber;
                clearInterval(timer);
                isComplete = true;
            }
            
            // Format the number based on the suffix and original format
            let displayValue;
            const plusSymbol = isComplete && (hasPlusPrefix || hasPlusSuffix) ? '+' : '';
            
            if (suffix.toLowerCase().includes('k')) {
                displayValue = prefix + (originalHasDecimal ? current.toFixed(1) + 'k' : Math.floor(current) + 'k') + plusSymbol;
            } else if (suffix.toLowerCase().includes('m')) {
                displayValue = prefix + (originalHasDecimal ? current.toFixed(1) + 'M' : Math.floor(current) + 'M') + plusSymbol;
            } else if (suffix.includes('%')) {
                displayValue = prefix + (originalHasDecimal ? current.toFixed(1) + '%' : Math.floor(current) + '%') + plusSymbol;
            } else {
                displayValue = prefix + Math.floor(current) + suffix + plusSymbol;
            }
            
            element.textContent = displayValue;
        }, 16);
    }
    
    // Initialize stats animation
    animateStats();
    
    // Video tabs functionality - pause videos when switching tabs
    function initVideoTabs() {
        const tabButtons = document.querySelectorAll('.module-accordion .nav-link[data-toggle="tab"]');
        const tabPanes = document.querySelectorAll('.module-accordion .tab-pane');
        
        tabButtons.forEach(button => {
            button.addEventListener('click', function() {
                const targetTabId = this.getAttribute('data-target');
                
                // Pause all videos in inactive tabs
                tabPanes.forEach(pane => {
                    if (pane.id !== targetTabId.replace('#', '')) {
                        // Pause HTML5 videos
                        const videos = pane.querySelectorAll('video');
                        videos.forEach(video => {
                            video.pause();
                        });
                        
                        // Pause YouTube videos (if using YouTube embeds)
                        const youtubeIframes = pane.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]');
                        youtubeIframes.forEach(iframe => {
                            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                        });
                        
                        // Pause Vimeo videos (if using Vimeo embeds)
                        const vimeoIframes = pane.querySelectorAll('iframe[src*="vimeo.com"]');
                        vimeoIframes.forEach(iframe => {
                            iframe.contentWindow.postMessage('{"method":"pause"}', '*');
                        });
                    }
                });
            });
        });
    }
    
    // Initialize video tabs functionality
    initVideoTabs();
    
    // Tab keyboard navigation following WAI-ARIA pattern
    function initTabKeyboardNavigation() {
        // Find all tab containers
        const tabContainers = document.querySelectorAll('.tabs-box, .module-accordion');
        
        tabContainers.forEach(container => {
            const tabButtons = Array.from(container.querySelectorAll('[role="tab"][data-toggle="tab"]'));
            
            if (tabButtons.length === 0) return;
            
            // Set up roving tabindex - only active tab is in tab order
            function updateTabIndex() {
                tabButtons.forEach(button => {
                    if (button.getAttribute('aria-selected') === 'true') {
                        button.setAttribute('tabindex', '0');
                    } else {
                        button.setAttribute('tabindex', '-1');
                    }
                });
            }
            
            // Initialize tabindex
            updateTabIndex();
            
            // Function to activate a tab
            function activateTab(button) {
                button.click();
                setTimeout(() => {
                    updateTabIndex();
                }, 50);
            }
            
            // Handle keyboard navigation on tabs
            tabButtons.forEach((button) => {
                button.addEventListener('keydown', function(e) {
                    const currentIndex = tabButtons.indexOf(this);
                    let newIndex;
                    
                    switch(e.key) {
                        case 'ArrowRight':
                        case 'ArrowDown':
                            e.preventDefault();
                            e.stopPropagation();
                            newIndex = (currentIndex + 1) % tabButtons.length;
                            activateTab(tabButtons[newIndex]);
                            tabButtons[newIndex].focus();
                            break;
                            
                        case 'ArrowLeft':
                        case 'ArrowUp':
                            e.preventDefault();
                            e.stopPropagation();
                            newIndex = (currentIndex - 1 + tabButtons.length) % tabButtons.length;
                            activateTab(tabButtons[newIndex]);
                            tabButtons[newIndex].focus();
                            break;
                            
                        case 'Home':
                            e.preventDefault();
                            e.stopPropagation();
                            activateTab(tabButtons[0]);
                            tabButtons[0].focus();
                            break;
                            
                        case 'End':
                            e.preventDefault();
                            e.stopPropagation();
                            activateTab(tabButtons[tabButtons.length - 1]);
                            tabButtons[tabButtons.length - 1].focus();
                            break;
                    }
                });
            });
        });
        
        // Handle Shift+Tab from within tab panel to go back to active tab
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Tab' && e.shiftKey) {
                const activeElement = document.activeElement;
                const activeTabPanel = activeElement.closest('[role="tabpanel"]');
                
                if (!activeTabPanel) return;
                
                const container = activeTabPanel.closest('.tabs-box, .module-accordion');
                if (!container) return;
                
                const activeTabButton = container.querySelector('[role="tab"][aria-selected="true"]');
                if (!activeTabButton) return;
                
                const focusableElements = Array.from(activeTabPanel.querySelectorAll(
                    'a[href], button:not([disabled]), iframe, video, [tabindex]:not([tabindex="-1"])'
                ));
                
                const isFirstElement = focusableElements.length === 0 || activeElement === focusableElements[0];
                const isPanelItself = activeElement === activeTabPanel;
                
                if (isFirstElement || isPanelItself) {
                    e.preventDefault();
                    activeTabButton.focus();
                }
            }
        });
    }
    
    // Initialize tab keyboard navigation
    initTabKeyboardNavigation();
    
    // Testimonials slider
    if (jq(".testimonials-slider").length) {
        jq(".testimonials-slider").slick(JSON.parse(document.getElementById("testimonialsSlickOptions").innerText));
    }
    
    // Handle keyboard events for dialog links with role="button"
    // Delay to ensure EqDialog has initialized first
    setTimeout(() => {
        document.querySelectorAll('a.eq-dialog[role="button"]').forEach(function(link) {
            link.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.click();
                }
            });
        });
    }, 100);
    
    // Footnote functionality
    setTimeout(() => {
        // Convert brackets to superscripts
        function convertBracesToSuperscript(text) {
            return text.replace(/\{\{([^}]+)\}\}/g, '<sup>$1</sup>');
        }
        
        const contents = document.querySelectorAll('h1, h2, h3, h4, th');
        if (contents) {
            contents.forEach((content) => {
                // Skip if this element contains an eq-dialog link to avoid breaking event listeners
                if (content.querySelector('.eq-dialog')) {
                    return;
                }
                content.innerHTML = convertBracesToSuperscript(content.innerHTML);
            });
        }
        
        // Check if the page contains the specified headings
        if (jq('.heading--h1:contains("Press Releases")').length || jq('.heading--h1:contains("News")').length) {
            return;
        }
        
        jq('h2 sup, h3 sup, .heading--h3 sup, li sup, p sup, .stat sup, th.label sup, .content-table th sup').each(function(index) {
            var supElement = jq(this);
            
            // Skip if this sup element is inside a dialog link or any other anchor tag
            if (supElement.closest('a').length > 0) {
                return;
            }
            
            var footnoteNumber = supElement.text();
            var uniqueSuffix = '-' + index;
            var footnoteId = 'footnote-' + footnoteNumber;
            var supId = 'sup-' + footnoteNumber + uniqueSuffix;
            
            // Assign a unique id to the sup element if it doesn't already have one
            if (!supElement.attr('id')) {
                supElement.attr('id', supId);
            }
            supElement[0].addEventListener('click', () => {
                last_footnote = supElement.attr('id');
            });
            
            // Find the corresponding footnote li element based on the number and assign a unique id to it
            var footnoteElement = jq('.footnotes ol li, .footnotes ul li').eq(footnoteNumber - 1);
    
            // Wrap the content of the footnote li in a p tag with a back link
            if (!footnoteElement.children('p').length) {
                footnoteElement.html('<p id="' + footnoteId + '" class="footnote-desc">' +
                    '<a href="#' + supId + '" class="footnote-return" aria-label="Back to Footnote ' + footnoteNumber + ' reference">' + footnoteNumber + '</a>. ' + footnoteElement.html() + 
                    '</p>');
            }
            
            // Create the anchor link for the sup element to point to the footnote
            supElement.wrap('<a class="footnote-anchor" href="#' + footnoteId + '" aria-describedby="' + footnoteId + '" tabindex="0" data-footnote="' + footnoteId + '"></a>');
        });
        
        // Handle scroll offset for footnote links to account for fixed header
        document.querySelectorAll('.footnote-anchor, .footnote-return').forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                
                const targetId = this.getAttribute('href').substring(1);
                const targetElement = document.getElementById(targetId);
                
                if (targetElement) {
                    const header = document.getElementById('header');
                    const headerHeight = header ? header.offsetHeight : 0;
                    const offset = 20; // Additional padding
                    
                    const elementPosition = targetElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerHeight - offset;
                    
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                    
                    // Update URL hash without triggering scroll
                    history.pushState(null, null, '#' + targetId);
                    
                    // Set focus for accessibility
                    targetElement.focus({preventScroll: true});
                }
            });
        });
    
        let footnote_section = document.querySelector('.footnotes .text');
        if (footnote_section) {
            let button = document.createElement('button');
            let arrow = document.createElement('span');
            button.classList.add('footnote-back-btn');
            button.setAttribute('aria-label', 'Back to content');
            arrow.classList.add('up-arrow');
        }
    }, 10);
});